class EnumHelper {
    getFriendlyName: (enumName?: string) => string | undefined = (enumName?: string) => {
        return enumName?.split('_').join(' ')
    };
}

export const enumHelper = new EnumHelper()
